import { render, staticRenderFns } from "./CategoriaUpdate.vue?vue&type=template&id=59e82c8d"
import script from "./CategoriaUpdate.vue?vue&type=script&lang=js"
export * from "./CategoriaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports